import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Routes } from '@angular/router';
import { SignOutService } from '@bfy/bfy-ui-shared';
import { of } from 'rxjs';
import { CONFIRM_EMAIL_ROUTES } from './confirm-email/confirm-email-routes';
import { LEGACY_TECHNOLOGY_ROUTES } from './constants/legacy-tech.routing';
import { HeaderStyle, ROOT_ROUTE_DATA } from './constants/root-routes';
import { CONTENT_ROUTE_DATA } from './content/content-routes';
import { ERRORS_ROUTES } from './errors/errors.routing';
import { PreEnrollmentService } from './pre-enrollment/pre-enrollment.service';
import { getRootComponentRoute } from './util/routing-util';

export const appRoutes: Routes = [
    getRootComponentRoute({
        path: ROOT_ROUTE_DATA.LANDING.PATH,
        pathMatch: 'full',
        loadComponent: () => import('./landing/landing.component'),
        title: 'Benefits For You - Home',
        headerStyle: HeaderStyle.Landing,
        page: ROOT_ROUTE_DATA.LANDING.PAGE,
    }),
    getRootComponentRoute({
        path: CONFIRM_EMAIL_ROUTES.CONFIRM_EMAIL.PATH,
        loadComponent: () => import('./confirm-email/confirm-email.component'),
        title: CONFIRM_EMAIL_ROUTES.CONFIRM_EMAIL.TITLE,
    }),
    {
        path: CONTENT_ROUTE_DATA.CONTENT.PATH,
        loadChildren: () => import('./content/content.routing'),
    },
    getRootComponentRoute({
        path: ROOT_ROUTE_DATA.PREENROLLMENT.PATH,
        //Commenting loadComponent to toggle off Pre Enrollment section
        loadComponent: () => import('./pre-enrollment/pre-enrollment.component'),
        page: ROOT_ROUTE_DATA.PREENROLLMENT.PAGE,
        title: ROOT_ROUTE_DATA.PREENROLLMENT.TITLE,
        headerStyle: HeaderStyle.PreEnrollment,
    }),
    getRootComponentRoute({
        path: ROOT_ROUTE_DATA.LOGOUT.PATH,
        children: [],
        canActivate: [
            (route: ActivatedRouteSnapshot) => {
                const signOutService = inject(SignOutService);
                signOutService.signOut(route?.queryParamMap?.get('returnPage') ?? undefined);
                return of(false);
            },
        ],
        headerStyle: HeaderStyle.None,
    }),
    getRootComponentRoute({
        path: ROOT_ROUTE_DATA.PREENROLLMENT_SUMMARY.PATH,
        loadComponent: () =>
            import('./pre-enrollment/pre-enrollment-summary/pre-enrollment-summary.component').then(
                (m) => m.PreEnrollmentSummaryComponent,
            ),
        //Navigate to the page only if pre-enrollment details are available
        canActivate: [
            () => {
                const preEnrollService = inject(PreEnrollmentService);
                if (preEnrollService?.isUserInPreEnrollmentPage()) {
                    return of(true);
                }
                return of(false);
            },
        ],
        //Disable user from navigating back to the page if pre-enrollment details are not available
        canDeactivate: [
            () => {
                const preEnrollService = inject(PreEnrollmentService);
                if (preEnrollService.isUserInPreEnrollmentPage()) {
                    return of(false);
                }
                return of(true);
            },
        ],
        page: ROOT_ROUTE_DATA.PREENROLLMENT_SUMMARY.PAGE,
        headerStyle: HeaderStyle.PreEnrollmentSummary,
        title: ROOT_ROUTE_DATA.PREENROLLMENT_SUMMARY.TITLE,
    }),
    ...ERRORS_ROUTES,
    ...LEGACY_TECHNOLOGY_ROUTES,
    {
        path: '**',
        redirectTo: ROOT_ROUTE_DATA.LANDING.PATH,
    },
];
